const groups = {
  }

  export {
    groups
  }
  
  export default {
    groups
  }
  


//////////////////
// WEBPACK FOOTER
// /data/code/gitlab/crossasia-itr-fulltextsearch-setting/groups.js
// module id = 0+0n
// module chunks = 1